import type { FaireProductEntity } from "../../entity_types/product";

export const p_7mqr08y: FaireProductEntity = {
  token: "p_7mqr08y",
  type: "product",
  name: "Dry Cookie Mix - Starter Kit",
  brandName: "Homemade-ish",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/e1b6ea6bf119ef548f6986675cad3959584a923e79ef33fe5975abed0d56a9f1.webp",
  priceDollars: 16,
  description: "Premium cookie starter kit with glitter surprise inside",
  categoryTokens: ["cat_food-snacks"],
  tags: ["nyc-local", "premium", "baking", "gift"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/e1b6ea6bf119ef548f6986675cad3959584a923e79ef33fe5975abed0d56a9f1.webp",
  weight: 0.8,
  dimensions: {
    width: 4,
    height: 5,
    depth: 4,
  },
  inStock: true,
};
